var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_12",
    "data-name": "Ebene 12",
    xmlns: "http://www.w3.org/2000/svg",
    width: 573.62,
    height: 567,
    viewBox: "0 0 573.62 567",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3, .cls-8 {\n        fill: #feebc1;\n      }\n\n      .cls-1, .cls-5, .cls-6, .cls-7 {\n        stroke: #511a00;\n      }\n\n      .cls-1, .cls-6, .cls-7, .cls-8 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-8 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1 {\n        stroke-width: 40px;\n      }\n\n      .cls-2 {\n        fill: #fa920d;\n      }\n\n      .cls-4 {\n        fill: #ea484c;\n      }\n\n      .cls-5, .cls-6 {\n        fill: none;\n      }\n\n      .cls-5, .cls-6, .cls-7 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8 {\n        stroke-width: 20px;\n      }\n\n      .cls-7 {\n        fill: #511a00;\n      }\n\n      .cls-8 {\n        stroke: #feebc1;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hashicode-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1166,530c85-183-22-245-22-245-85,25-130,73-130,73-35-15-82-15-82-15s-47,0-82,15c0,0-45-48-130-73,0,0-107,62-22,245,0,0-10.22,27.68-10.4,67.72A221.15,221.15,0,0,0,712,701c45,87,147,111,219,111h2c72,0,174-24,219-111,19.44-37.58,24.7-74.6,24.39-104.53C1176,557.1,1166,530,1166,530Z",
    transform: "translate(-645.19 -265)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_7",
    "data-name": "Ebene 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_5",
    "data-name": "Ebene 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1166,530c85-183-22-245-22-245-85,25-130,73-130,73-35-15-82-15-82-15s-47,0-82,15c0,0-45-48-130-73,0,0-107,62-22,245,0,0-10.22,27.68-10.4,67.72A221.15,221.15,0,0,0,712,701c45,87,147,111,219,111h2c72,0,174-24,219-111,19.44-37.58,24.7-74.6,24.39-104.53C1176,557.1,1166,530,1166,530Z",
    transform: "translate(-645.19 -265)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6",
    "data-name": "Ebene 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1176.39,596.47c-16.33,10.45-38.91,19.87-68.39,21.53-71,4-96-20-96-20s-23.86-26.84-80.49-27H931c-57,0-81,27-81,27s-25,24-96,20c-28.3-1.59-50.25-10.34-66.4-20.28A221.15,221.15,0,0,0,712,701c45,87,147,111,219,111h2c72,0,174-24,219-111C1171.44,663.42,1176.7,626.4,1176.39,596.47Z",
    transform: "translate(-645.19 -265)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "326.09 433.36 285.81 409 241.95 436.3 258.37 486.05 285.81 495 320.3 476.45 326.09 433.36"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Outlines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M656.36,143",
    transform: "translate(-645.19 -265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M829,672s20.1,34.54,55,28c16-3,47-15,47-68",
    transform: "translate(-645.19 -265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1033,672s-20.1,34.54-55,28c-16-3-47-15-47-68",
    transform: "translate(-645.19 -265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M785,554s34-29,70,0",
    transform: "translate(-645.19 -265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1077,554s-34-29-70,0",
    transform: "translate(-645.19 -265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M931,596s-39-2-36,18,18,29.5,36,26.25c18,3.25,33-6.25,36-26.25S931,596,931,596Z",
    transform: "translate(-645.19 -265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M887.15,699.33S885,762,931,762",
    transform: "translate(-645.19 -265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M974.85,699.33S977,762,931,762",
    transform: "translate(-645.19 -265)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 285.81,
    y1: 414,
    x2: 285.81,
    y2: 444
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3",
    "data-name": "Ebene 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M732,353s-26,43,1,124c0,0,27-70,73-79C806,398,759,353,732,353Z",
    transform: "translate(-645.19 -265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1130,353s26,43-1,124c0,0-27-70-73-79C1056,398,1103,353,1130,353Z",
    transform: "translate(-645.19 -265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M841,454s-34,2-28,23,36,14,36,14S865,473,841,454Z",
    transform: "translate(-645.19 -265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1021,454s34,2,28,23-36,14-36,14S997,473,1021,454Z",
    transform: "translate(-645.19 -265)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b4cb002aa18248329371b92fa6590ffa.svg";
export { ForwardRef as ReactComponent };